import { render } from "./InputPriority.vue?vue&type=template&id=2ad983b9&scoped=true"
import script from "./InputPriority.vue?vue&type=script&lang=js"
export * from "./InputPriority.vue?vue&type=script&lang=js"

import "./InputPriority.vue?vue&type=style&index=0&id=2ad983b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad983b9"]])

export default __exports__